import React from 'react'


export const RenderDoneDialog= (doneMessage,renderCloseMessage,childControls)=>{
    
    return(
        <div className="user-message-wrapper fadeInDown">
        <div className="login-form-content">
          <div  className="pcrb-logo"></div>
          <form>
            <h4 className="code-login-welcome">
              {doneMessage.message}   
              { doneMessage.subMessage &&
               <p>
                   { doneMessage.subMessage }                  
                </p>
            }               
            </h4>
            {renderCloseMessage &&                            
                <div style={{margin:"20px"}}>
                Close browser tab or click <a href="http://www.pcrb.com">here</a> to visit the PCRB/DCRB home page
                </div>                
            }            
          </form>                      
          {childControls}
        </div>
      </div>
    );    

}

